import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Row, Col, Label } from "reactstrap";
import StoreContext from "./../../../Store/Context";
import { getHourAsigTeacher } from "../../Constants/Services";
import { IHour } from "../../Constants/Interfaces";
import {
  HOUR_CLASS,
  validateTokenStorage,
  HOUR_BODY_PRINT,
} from "./../../Constants/Util";
import { printComponent } from "react-print-tool";

interface IHourState {
  typePerson: string;
  dataHour: IHour[];
}

class HourTeacher extends Component<RouteComponentProps<{}>, IHourState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      typePerson: "teacher",
      dataHour: [],
    };

    this.fetchHour = this.fetchHour.bind(this);
    this.onClickPrint = this.onClickPrint.bind(this);
  }

  async fetchHour() {
    const response = await getHourAsigTeacher(this.context.per_id);
    this.setState({
      dataHour: response,
    });
  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchHour();
  }

  onClickPrint = () => {
    const props = this.state;
    printComponent(
      <HOUR_BODY_PRINT
        typePerson={props.typePerson}
        dataHour={props.dataHour}
      />
    );
  };

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Row>
          {props.dataHour.length > 0 ? (
            <Col sm={12} className="overflow-auto" id="schedule">
              <HOUR_CLASS
                dataHour={props.dataHour}
                type={props.typePerson}
                onPrint={this.onClickPrint}
              />
            </Col>
          ) : (
            <React.Fragment>
              <Col xs={12} className="text-center">
                <h5 className="font-weight-bold">Horario</h5>
              </Col>
              <Col sm={12} className="text-center">
                <Label className="font-weight-bold result-none">
                  Sin Resultados
                </Label>
              </Col>
            </React.Fragment>
          )}
        </Row>
      </React.Fragment>
    );
  }
}
export default HourTeacher;
